export default __webpack_public_path__ + "static/media/darkmode-logout.5394aeb6.svg";